import { z } from "zod";

const base = z.object({
  metric: z.enum(["LCP", "INP", "CLS"]),
  value: z.number(),
  rating: z.enum(["good", "needs-improvement", "poor"]),
  threshold: z.enum(["needs-improvement", "poor"]),
  id: z.string(),
  delta: z.number(),
  navigationType: z.string().optional(),

  pageUrl: z.string(),
  userAgent: z.string().optional(),

  thresholds: z.object({
    needsImprovement: z.number(),
    poor: z.number(),
  }),
});

const lcpAttribution = z
  .object({
    target: z.string().optional(),
    element: z.string().optional(),
    lcpElement: z.string().optional(),
    url: z.string().optional(),
    timeToFirstByte: z.number().optional(),
    resourceLoadDelay: z.number().optional(),
    resourceLoadDuration: z.number().optional(),
    elementRenderDelay: z.number().optional(),
  })
  .partial()
  .optional();

const inpAttribution = z
  .object({
    interactionTarget: z.string().optional(),
    inpEventTarget: z.string().optional(),
    eventType: z.string().optional(),
    loadState: z.string().optional(),
  })
  .partial()
  .optional();

const clsAttribution = z
  .object({
    largestShiftTarget: z.string().optional(),
  })
  .partial()
  .optional();

const lcpPayload = base.merge(
  z.object({
    metric: z.literal("LCP"),
    attribution: lcpAttribution,
  })
);

const inpPayload = base.merge(
  z.object({
    metric: z.literal("INP"),
    attribution: inpAttribution,
  })
);

const clsPayload = base.merge(
  z.object({
    metric: z.literal("CLS"),
    attribution: clsAttribution,
  })
);

export const coreWebVitalsThresholdSchema = z.union([
  lcpPayload,
  inpPayload,
  clsPayload,
]);
export default coreWebVitalsThresholdSchema;

export type CoreWebVitalsThresholdPayload = z.infer<
  typeof coreWebVitalsThresholdSchema
>;
export type LcpAttribution = z.infer<typeof lcpAttribution>;
export type InpAttribution = z.infer<typeof inpAttribution>;
export type ClsAttribution = z.infer<typeof clsAttribution>;
